module.exports = __webpack_public_path__ + "static/org_b-tech-8186826c0aaf7995a80077859bf6d2c6.png";